var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveLetter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 45,
    viewBox: "0 0 67 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4422 45H4.55778C2.36409 45 0.585693 43.2216 0.585693 41.0279V3.97207C0.585693 1.7784 2.36409 0 4.55778 0H62.4422C64.6359 0 66.4143 1.7784 66.4143 3.97207V41.0279C66.4143 43.2216 64.6359 45 62.4422 45Z",
    fill: "#E8C5A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4406 0H58.467C60.6617 0 62.4406 1.77762 62.4406 3.97055V41.0293C62.4406 43.2222 60.6615 44.9999 58.467 44.9999H62.4406C64.635 45 66.414 43.2222 66.414 41.0295V3.97055C66.414 1.77762 64.635 0 62.4406 0Z",
    fill: "#D4B090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0209 0.952962L33.5001 22.5L1.97925 0.952962C2.67328 0.358716 3.57521 0 4.55929 0H62.4407C63.425 0 64.3269 0.358716 65.0209 0.952962Z",
    fill: "#F8E4D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0208 44.047C64.3268 44.6413 63.4247 45 62.4406 45H4.55918C3.57509 45 2.67303 44.6413 1.979 44.047L33.5 22.5L65.0208 44.047Z",
    fill: "#F8E4D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3869 15.8385C33.4425 15.9165 33.5576 15.9165 33.6133 15.8385C34.062 15.2105 35.8436 13.0278 38.9306 13.0278C42.1456 13.0278 44.3611 16.085 44.3611 19.6456C44.3611 23.7229 41.4047 28.5394 33.7483 32.7456C33.5944 32.83 33.4056 32.83 33.2517 32.7456C25.5953 28.5394 22.6389 23.7229 22.6389 19.6456C22.6389 16.0852 24.8546 13.0278 28.0694 13.0278C31.1565 13.0278 32.938 15.2105 33.3869 15.8385Z",
    fill: "#DC527C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9305 13.0278C38.1364 13.0278 37.4295 13.1729 36.8086 13.398C38.9913 14.3133 40.3874 16.82 40.3874 19.6454C40.3874 23.3982 37.8814 27.7768 31.5132 31.7297C32.064 32.0716 32.6424 32.4105 33.2516 32.7455C33.4055 32.83 33.5944 32.83 33.7483 32.7455C41.4046 28.5392 44.3611 23.7228 44.3611 19.6454C44.3611 16.085 42.1454 13.0278 38.9305 13.0278Z",
    fill: "#BF476C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveLetter1);
export default __webpack_public_path__ + "static/media/love-letter-1.ac6a19d60fce74bf6e2130843d5ab16d.svg";
export { ForwardRef as ReactComponent };